<!--suppress ALL -->
<div class="asset-detail" [ngClass]="{'show': displayAssetDetail}">
    <div class="page-wrapper">
    @if(fullAsset) {
        <div class="row">
            <div class="col-12">
                <div class="icon-bar">
                    <button mat-icon-button (click)="close()"><mat-icon  fontIcon="close"></mat-icon></button>
                </div>
            </div>
        </div>
        @if(fullAsset) {
        <div class="row">
            <div class="col-8">
                <div class="row">
                    <div class="col-12">
                        <div class="header-bar">
                            <h2>{{fullAsset.title}}</h2>
                            @if(fullAsset['copyright']) {
                                <h3><span class="name">{{ 'property.copyright'|translate }}</span>: <span class="value" [innerHTML]="fullAsset['copyright']"></span></h3>
                            }
                            <div class="info-bar">
                                <div class="info">
                                    <span>{{fullAsset.uuid}}</span>
                                </div>
                                @if(user) {
                                    <div class="tool-bar">
                                        @if (!editProperties) {
                                            <button mat-icon-button (click)="toggleEdit($event)" [disabled]="!canEdit() || editBinary"><mat-icon fontIcon="edit" [matTooltip]="'asset.editAsset' | translate"></mat-icon></button>
                                        } @else {
                                            <button mat-icon-button (click)="toggleEdit($event)" [matTooltip]="'asset.stopEditAsset' | translate"><mat-icon fontIcon="close"></mat-icon></button>
                                        }
                                        @if(user.effectiveRoles.ROLE_ASSET_DELETE) {
                                            <button mat-icon-button [matTooltip]="'action.deleteAssets'|translate" (click)="deleteAssets()" [disabled]="isEditing()">
                                                <mat-icon  aria-hidden="false" fontIcon="delete" ></mat-icon>
                                            </button>
                                        }
                                        <button mat-icon-button (click)="addToCollection($event)" [disabled]="isEditing()"><mat-icon  fontIcon="add" [matTooltip]="'asset.addToCollection' | translate"></mat-icon></button>
                                        <button mat-icon-button  (click)="shareAsset($event)" [disabled]="isEditing()" [matTooltip]="'asset.shareAsset' | translate"><mat-icon fontIcon="share"></mat-icon></button>
                                        @if(fullAsset.assetLinks && fullAsset.assetLinks.copyLinks && fullAsset.assetLinks.copyLinks.length > 0) {
                                            <button [matMenuTriggerFor]="menu" mat-icon-button [matTooltip]="'asset.copyLinks' | translate"><mat-icon>content_copy</mat-icon></button>
                                            <mat-menu #menu="matMenu">
                                                @for(entry of fullAsset.assetLinks.copyLinks; track entry.name) {
                                                    <button mat-menu-item (click)="copyValue(entry.value)">{{'asset.copyLinks.' + entry.name | translate}}</button>
                                                }
                                            </mat-menu>
                                        }
                                        <button mat-icon-button (click)="fileInput.click()" [disabled]="!canEdit() || isEditing()" [matTooltip]="'asset.uploadNewImage' | translate"><mat-icon fontIcon="upload_file"></mat-icon></button>
                                        <input #fileInput type="file" (change)="replaceBinary($event)" style="display: none">
                                    </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-1">
                        <div class="btn-wrapper">
                        @if(!editProperties && (currentSelectedAssetIndex || currentSelectedAssetIndex === 0)) {
                            <button mat-icon-button  (click)="prevAsset()"><mat-icon fontIcon="arrow_left"></mat-icon></button>
                        } @else {
                            <div></div>
                        }
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="asset-wrapper">
                            <div class="asset">
                                @if (editBinary) {
                                    <mat-progress-bar mode="determinate" [value]="editBinaryProgress"></mat-progress-bar>
                                }
                                @if(!isVideo && fullAsset.thumbnails  && !isPdf) {
                                    <div class="image-wrapper" [ngClass]="{'trans-bg': fullAsset.assetBinary && fullAsset.assetBinary.imageHasAlpha }">
                                        @if(hasImage) {
                                            <img [src]="fullAsset.thumbnails.md" alt="preview" (error)="hasImage = false">
                                        } @else {
                                            <div class="text-wrapper">
                                                <span class="no-image">No image available</span>
                                            </div>
                                        }
                                    </div>
                                }
                                @if(isPdf) {
                                    <div class="image-wrapper"  [ngClass]="{'trans-bg': fullAsset.assetBinary && fullAsset.assetBinary.imageHasAlpha }">
                                        @if(hasImage) {
                                            <img [src]="fullAsset.thumbnails.md" alt="preview" (error)="hasImage = false">
                                        } @else {
                                            <div class="text-wrapper">
                                                <span class="no-image">No image available</span>
                                            </div>
                                        }
                                        <div class="view-pdf">
                                            <button (click)="openPdf(pdfSourceUrl)" mat-raised-button  [disabled]="isEditing()">
                                                <mat-icon fontIcon="visibility"></mat-icon>{{'view_pdf' | translate}}</button>
                                        </div>
                                    </div>
                                }
                                @if(isVideo) {
                                    <div class="video-wrapper">
                                        <video width="100%"
                                               height="auto"
                                               class="video-player"
                                               controls
                                               controlsList="nodownload"
                                               muted
                                               preload="auto"
                                               poster="{{fullAsset.thumbnails.md}}">
                                            @if(fullAsset.assetLinks && fullAsset.assetLinks.videoSourceUrl) {
                                                <source [src]="fullAsset.assetLinks.videoSourceUrl"
                                                        type="{{fullAsset.assetBinary.mimeType}}">
                                            }

                                        </video>

                                    </div>
                                }
                            </div>

                        </div>
                    </div>
                    <div class="col-1">
                        <div class="btn-wrapper">
                            @if(!editProperties && (currentSelectedAssetIndex || currentSelectedAssetIndex === 0)) {
                                <button mat-icon-button (click)="nextAsset()"><mat-icon  fontIcon="arrow_right"></mat-icon></button>
                            }@else {
                                <div></div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class = col-12>
                        <div class="detail-wrapper">
                            @if (!editProperties) {
                                <div class="detail-data" appFullHigh bottomOffset=180>
                                <app-asset-detail-property name="title" [value]="fullAsset.title"></app-asset-detail-property>
                                @if(fullAsset.skus && fullAsset.skus.length > 0) {
                                    <app-asset-detail-property name="skus" [value]="fullAsset.skus"></app-asset-detail-property>
                                }
                                <!-- asset metrics -->
                                    <div class="entry">
                                        <span class="name">{{ 'property.asset_metrics'|translate }}</span>
                                        @if(fullAsset.assetBinary.fileSize) {
                                            <span class="value"> {{fullAsset.assetBinary.fileSize | byteToMb}}</span>
                                        }
                                        @if(fullAsset.assetBinary.width && fullAsset.assetBinary.height) {
                                            <span class="value">, {{fullAsset.assetBinary.width}} x {{fullAsset.assetBinary.height}} px</span>
                                        }
                                        @if(fullAsset.assetBinary.imageResolution) {
                                            <span class="value">, {{fullAsset.assetBinary.imageResolution}}<span> DPI</span></span>
                                        }
                                        <br>
                                        @if(fullAsset.assetBinary.fileExtension) {
                                            <span class="value">{{fullAsset.assetBinary.fileExtension}}</span>
                                        }
                                        @if(fullAsset.assetBinary.colorspace) {
                                            <span class="value">, {{fullAsset.assetBinary.colorspace}}</span>
                                        }
                                        @if(fullAsset.assetBinary.imageHasClippingPath) {
                                            , <mat-icon class="icon" fontIcon="route"></mat-icon>
                                        }
                                    </div>

                                    @if(fullAsset['brand'] && Array.isArray(fullAsset['brand'] )) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.brand'|translate }}</span>
                                            @if(fullAsset['brand'] && Array.isArray(fullAsset['brand'])) {
                                                @for(brand of fullAsset['brand'] //noinspection ForBlockNonIterableVar; track brand; let last =  $last) {
                                                    <span class="value">{{'property.brand.' + brand | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['division'] && Array.isArray(fullAsset['division'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.division'|translate }}</span>
                                            @if(fullAsset['division'] && Array.isArray(fullAsset['division'])) {
                                                @for(entry of fullAsset['division']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.division.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['sport'] && Array.isArray(fullAsset['sport'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.sport'|translate }}</span>
                                            @if(fullAsset['sport'] && Array.isArray(fullAsset['sport'])) {
                                                @for(entry of fullAsset['sport']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.sport.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['asset_type'] && Array.isArray(fullAsset['asset_type'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.asset_type'|translate }}</span>
                                            @if(fullAsset['asset_type'] && Array.isArray(fullAsset['asset_type'])) {
                                                @for(entry of fullAsset['asset_type']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.asset_type.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['asset_category'] && Array.isArray(fullAsset['asset_category'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.asset_category'|translate }}</span>
                                            @if(fullAsset['asset_category'] && Array.isArray(fullAsset['asset_category'])) {
                                                @for(entry of fullAsset['asset_category']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.asset_category.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['content'] && Array.isArray(fullAsset['content'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.content'|translate }}</span>
                                            @if(fullAsset['content'] && Array.isArray(fullAsset['content'])) {
                                                @for(entry of fullAsset['content']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.content.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['channel'] && Array.isArray(fullAsset['channel'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.channel'|translate }}</span>
                                            @if(fullAsset['channel'] && Array.isArray(fullAsset['channel'])) {
                                                @for(entry of fullAsset['channel']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.channel.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['product_category'] && Array.isArray(fullAsset['product_category'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.product_category'|translate }}</span>
                                            @if(fullAsset['product_category'] && Array.isArray(fullAsset['product_category'])) {
                                                @for(entry of fullAsset['product_category']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.product_category.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['product_type'] && Array.isArray(fullAsset['product_type'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.product_type'|translate }}</span>
                                            @if(fullAsset['product_type'] && Array.isArray(fullAsset['product_type'])) {
                                                @for(entry of fullAsset['product_type']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.product_type.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['year'] && Array.isArray(fullAsset['year'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.year'|translate }}</span>
                                            @if(fullAsset['year'] && Array.isArray(fullAsset['year'])) {
                                                @for(entry of fullAsset['year']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.year.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['season'] && Array.isArray(fullAsset['season'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.season'|translate }}</span>
                                            @if(fullAsset['season'] && Array.isArray(fullAsset['season'])) {
                                                @for(entry of fullAsset['season']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.season.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['language'] && Array.isArray(fullAsset['language'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.language'|translate }}</span>
                                            @if(fullAsset['language'] && Array.isArray(fullAsset['language'])) {
                                                @for(entry of fullAsset['language']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.language.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['continent'] && Array.isArray(fullAsset['continent'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.continent'|translate }}</span>
                                            @if(fullAsset['continent'] && Array.isArray(fullAsset['continent'])) {
                                                @for(entry of fullAsset['continent']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.continent.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['country'] && Array.isArray(fullAsset['country'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.country'|translate }}</span>
                                            @if(fullAsset['country'] && Array.isArray(fullAsset['country'])) {
                                                @for(entry of fullAsset['country']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.country.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['gender'] && Array.isArray(fullAsset['gender'])) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.gender'|translate }}</span>
                                            @if(fullAsset['gender'] && Array.isArray(fullAsset['gender'])) {
                                                @for(entry of fullAsset['gender']; track entry; let last =  $last) {
                                                    <span class="value">{{'property.gender.' + entry | translate}}</span>
                                                    @if(!last){
                                                        <span>, </span>
                                                    }
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['tags'] && fullAsset['tags'].length > 0) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.tags'|translate }}</span>
                                            @for(tag of fullAsset['tags']; track tag; let last =  $last) {
                                                <span class="value">{{tag}}</span>
                                                @if(!last){
                                                    <span>, </span>
                                                }
                                            }
                                        </div>
                                    }
                                    @if(fullAsset['description']) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.description'|translate }}</span>
                                            <span class="value" [innerHTML]="fullAsset['description'] | line2Br"></span>
                                        </div>
                                    }
                                    @if(fullAsset.createdby) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.createdby'|translate }}</span>
                                            <span class="value">{{fullAsset.createdby}}</span>
                                        </div>
                                    }
                                    @if(fullAsset.createdAt) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.createdAt'|translate }}</span>
                                            <span class="value">{{fullAsset.createdAt | dateLocale : 'short'}}</span>
                                        </div>
                                    }
                                    @if(fullAsset.updatedAt) {
                                        <div class="entry">
                                            <span class="name">{{ 'property.updatedAt'|translate }}</span>
                                            <span class="value">{{fullAsset.updatedAt | dateLocale : 'short'}}</span>
                                        </div>
                                    }
                                    @if(fullAsset['copyright']) {
                                        <div class="entry">
                                             <span class="name">{{ 'property.copyright'|translate }}</span>
                                             <span class="value"  [innerHTML]="fullAsset['copyright'] | line2Br"></span>
                                         </div>
                                    }



                                @if(fullAsset?.isLimited) {
                                    <div class="entry">
                                        <span class="name">{{ 'property.isLimited'|translate }}</span>
                                        <mat-icon class="icon" fontIcon="check"></mat-icon>
                                    </div>
                                }
                                @if(fullAsset?.isArchived) {
                                    <div class="entry">
                                        <span class="name">{{ 'property.isArchived'|translate }}</span>
                                        <mat-icon class="icon" fontIcon="check"></mat-icon>
                                    </div>
                                }


                                <!--{{ 'property.' + prop.name|translate }}-->
                            </div>
                            } @else {
                                <div class="detail-data detail-data-edit" appFullHigh bottomOffset=180 [formGroup]="propertiesForm">
                                    @for (prop of eligibleProperties; track prop.name) {
                                        @if (getControl(prop)) {
                                        <app-asset-detail-formfield [prop]="prop" [control]="getControl(prop)!!"></app-asset-detail-formfield>
                                        }
                                    }
                                </div>
                            }
                            @if(canDownload() && !editProperties) {
                                <button (click)="startDownload()" mat-raised-button class="button mt-3" [disabled]="isEditing()">
                                    <mat-icon fontIcon="download_file"></mat-icon>{{'download_all_files' | translate}}</button>
                            }
                            @else if (editProperties) {
                                <button (click)="saveProperties()" [disabled]="!propertiesForm.valid" mat-raised-button class="button mt-3">
                                    <mat-icon fontIcon="check"></mat-icon>{{'asset.properties.save' | translate}}</button>
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
        }
    }
    </div>

</div>
